<template>
  <div class="ee-form-item" :style="style" :class="{'is-error': errMsg}">
    <div v-if="label" :style="{width: `${labelWidth}px`}" class="ee-form-item__label" :class="{'is-required': isRequired}">
      {{label}}
    </div>
    <div class="ee-form-item__content" :style="{marginLeft: `${labelWidth}px`}">
      <slot></slot>
      <span class="ee-form-item__bottom-bar">
        <slot name="bttom-bar"></slot>
      </span>
      <span class="ee-form-item__error-msg">{{errMsg}}</span>
    </div>
  </div>
</template>
<script>
  import findNode from '../mixin/findNode'
  import { validField } from '../utils/valid'
  export default {
    compName: 'ee-form-item',
    mixins: [findNode],
    props: {
      errorMsg: null,
      prop: String,           // 属性名
      inline: Boolean,        // 自动宽度 默认 false 占整行
      label: String,          // 标签文本
      labelWidth: Number,  // 标签文本宽度
      contentWidth: Number // 内容区宽度
    },
    data () {
      return {
        isRequired: false,
        errMsg: '',
        form: this.getParent('ee-form')
      }
    },
    watch: {
      errorMsg () {
        this.errMsg = this.errorMsg
      }
    },
    computed: {
      fieldValue: {
        cache: false,
        get () {
          const data = this.form.dataObject
          return data[this.prop]
        }
      },
      style () {
        const styleRule = {}
        if (this.inline) {
          styleRule.display = 'inline-block'
        }
        return styleRule
      }
    },
    methods: {
      validate (trigger) {
        if (this.prop) {
          const rules = this.form.rules[this.prop]
          if (rules && rules.length > 0) {
            return Promise.all(rules.map(rule => !trigger || rule.trigger === trigger ? new Promise((resolve, reject) => {
              validField(rule, this.fieldValue, err => {
                if (err) {
                  this.errMsg = err
                  reject()
                } else {
                  resolve()
                }
              })
            }) : Promise.resolve())).then(() => (this.errMsg = ''))
          }
        }
        return Promise.resolve()
      },
      resetField () {
        this.form.dataObject[this.prop] = this.initialValue
      },
      getRules () {
        if (this.prop) {
          return this.form.rules[this.prop]
        }
      },
      handleValidBlur () {
        this.validate('blur')
      },
      handleValidChange () {
        this.validate('change')
      }
    },
    mounted () {
      if (this.prop) {
        // 若设置了prop属性 将元素注册到form里
        this.form.$emit('ee.form.addField', this)
        Object.defineProperty(this, 'initialValue', {
          value: this.fieldValue
        })
        const rules = this.getRules()
        if (rules && rules.length > 0) {
          rules.every(rule => {
            if (rule.required) {
              this.isRequired = true
              return false
            }
            return true
          })
          this.$on('ee.form.blur', this.handleValidBlur)
          this.$on('ee.form.change', this.handleValidChange)
        }
      }
    },
    beforeDestroy () {
      this.form.$emit('ee.form.removeField', this)
    }
  }
</script>
<style src="../style/form-item.css"></style>



// WEBPACK FOOTER //
// src/packages/form/FormItem.vue?4b08679b